import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["input"];

  sync() {
    const query = this.inputTarget.value;
    const activePane = this.element.querySelector(".academy-hub__panels .tab-pane.active");
    const scope = activePane || this.element;
    const indexes = scope.querySelectorAll("[data-academy-hub-index-search]");

    indexes.forEach((indexRoot) => {
      const input = indexRoot.querySelector('[data-search-target="input"]');
      const form = indexRoot.querySelector('[data-search-target="form"]');
      if (!input || !form) return;

      if (input.value === query) return;

      input.value = query;
      input.dispatchEvent(new Event("input", { bubbles: true }));
    });
  }
}
